import React from "react";
import "./styles.less";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Title } from "../../components/NewTitle";

export const CommonPageLink = (props) => {
  const { pagesLink } = props;
  const { t } = useTranslation();
  return (
    <section>
      <div className="common-page-link">
        <div className="inner">
          {/* <h2 className="link-page-title">{t("common.pageLink.title")}</h2> */}
          <Title title={t("common.pageLink.title")} align="left" />
          <div className="link-page-warp">
            {pagesLink.map((pageLink) => (
              <Link
                title={pageLink.title}
                to={pageLink.jumpLink}
                style={{ textDecoration: "none" }}
              >
                <div className="link-page">
                  <div className="icon">
                    <img
                      className="icon-default"
                      src={pageLink.defaultImg}
                      alt="Authing"
                    />
                    <img
                      className="icon-choosed"
                      src={pageLink.checkedImg}
                      alt="Authing"
                    />
                  </div>
                  <div className="content-warp">
                    <div className="title">{pageLink.title}</div>
                    <div className="description">{pageLink.description}</div>
                  </div>
                  <Link to={pageLink.jumpLink} className="link">
                    {t("common.common-more")}
                  </Link>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
